const getSendAllToAccountingStatus = `getClosingStatusPayrollPeriod{sendAllToAccounting}`;

export default getSendAllToAccountingStatus;
